// extracted by mini-css-extract-plugin
module.exports = {"container":"TabActionBar_container__2wg0q","tabRow":"TabActionBar_tabRow__3298d","tab":"TabActionBar_tab__2icER","active":"TabActionBar_active__sibPY"};